import React, { useEffect, useRef, useState } from 'react'
import { getServerURL } from '../helper/envConfig';
import { Button, Card, Col, Row, Modal, Table, Form, InputGroup } from 'react-bootstrap'
import NavSearch from '../layouts/AdminLayout/NavBar/NavLeft/NavSearch';
import api from '../helper/api';
import { errorResponse } from '../helper/error';
import { toast } from 'react-toastify';
import Loader from './Loader/Loader';
import PaginationC from './pagination';
import camera from '../assets/images/svg/camera.svg';

const customerReview = (props) => {
    const serverURL = getServerURL()
    const fileInputRef = useRef(null);
    const [deleteModalShow, setDeleteModalShow] = useState(false);
    const [modalShow, setModalShow] = useState(false);
    const [states, setStates] = useState({})
    const [validated, setValidated] = useState(false);
    const [data, setData] = useState([])
    const [deleteData, setDeleteData] = useState();
    const [loading, setLoading] = useState(true);
    const [subLoader, setSubLoader] = useState(false);
    const [mode, setMode] = useState();
    const [selectedImage, setSelectedImage] = useState();
    const [paginationData, setPaginationData] = useState({})
    const [searchText, setSearchText] = useState("");

    const [page, setPage] = useState(1)

    useEffect(() => {
        getCustomerReview();
    }, [page]);

    const getCustomerReview = (event) => {
        api.getWithToken(`${serverURL}customer-review/?page=${page}`)
            .then(async (res) => {
                const { data, links, page, page_size, total, total_pages } = res?.data;
                setPaginationData({ links, page, page_size, total, total_pages })
                setLoading(false)
                if (res?.data?.success === true) {
                    setData(res?.data?.data);
                }
            })
            .catch((e) => {
                setLoading(false)
            });
    };

    const handleImageClick = () => {
        fileInputRef.current.click();
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "photo") {
            const file = e.target.files[0];
            if (file) {
                const reader = new FileReader();
                reader.onloadend = () => {
                    setSelectedImage(reader.result);
                };
                reader.readAsDataURL(file);
                setStates({
                    ...states,
                    [name]: file,
                });
            }
        } else
            setStates((prevValues) => ({
                ...prevValues,
                [name]: value.trimStart(),
            }));
    };

    const handleSubmit = (event) => {
        setSubLoader(true)
        const form = event.currentTarget;
        event.preventDefault();
        if (form.checkValidity()) {
            setValidated(false);
            const type = Boolean(mode) ? "postWithToken" : "putWithToken";
            const formData = new FormData();
            formData.append("description", states?.description);
            formData.append("author", states?.author);
            if (states?.photo) {
                formData.append("photo", states?.photo);
            }
            if (!Boolean(mode) && states?.id) {
                formData.append("id", states?.id);
            }

            api[type](`${serverURL}customer-review/`, formData)
                .then(async (res) => {
                    setModalShow(false)
                    setStates({})
                    form.reset();
                    setSubLoader(false)
                    if (res?.data?.success === true) {
                        toast.success(res?.data?.message);
                        getCustomerReview();
                    } else if (res?.data?.success === false) {
                        if (typeof res?.data?.message === "string")
                            toast.error(res?.data?.message);
                    }
                })
                .catch((e) => {
                    setSubLoader(false)
                    errorResponse(e);
                });
        } else {
            setValidated(true);
            setSubLoader(false)
            event.stopPropagation();
        }
    };

    const deleteCustomerReview = () => {
        setSubLoader(true)
        api.deleteWithToken(`${serverURL}customer-review/${deleteData}`)
            .then(async (res) => {
                setDeleteModalShow(false)
                setSubLoader(false)
                if (res?.data?.success === true) {
                    toast.success(res?.data?.message);
                    getCustomerReview()
                } else if (res?.data?.success === false) {
                    if (typeof res?.data?.message === "string")
                        toast.error(res?.data?.message);
                }
            })
            .catch((e) => {
                setSubLoader(false)
                errorResponse(e);
            });
    }

    const handleClose = () => {
        setModalShow(false);
        setSelectedImage(null);
    }
    return (
        <>

            <Card className="user-list">
                <Card.Header>
                    <div className='d-flex justify-content-between align-items-center'>
                        <Card.Title as="h4">{props?.title || ""}</Card.Title>
                        <div className='d-flex align-items-center'>
                            <header className="navbar pcoded-header" style={{ backgroundColor: "#fff" }}>
                                <NavSearch searchText={searchText} setSearchText={setSearchText} /></header>
                            <Button variant={"outline-primary"} className='m-0' onClick={() => { setMode(true); setStates({}); setModalShow(true) }}>
                                {"Add"}
                            </Button>
                        </div>
                    </div>
                </Card.Header>
                <Card.Body>
                    <Table responsive hover className='product-table'>
                        <thead>
                            <tr>
                                <th>No</th>
                                <th>Image</th>
                                <th>Description</th>
                                <th>Author</th>
                                {/* <th>Is Active</th> */}
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Boolean(loading) ?
                                <tr>
                                    <td colSpan={6} className='text-center'>
                                        <Loader loading={loading} />
                                    </td>
                                </tr>
                                :
                                Boolean(data?.length) ? data?.map((item, index) =>
                                    <tr key={index + 1}>
                                        <td>{(10 * (page - 1)) + (index + 1)}</td>
                                        <td>
                                            <img className="rounded-circle" style={{ width: '100%', maxWidth: "40px", height: "40px" }} src={item?.photo} alt="activity-user" />
                                        </td>
                                        <td>
                                            <h6 className="m-0">{item?.description || "-"} </h6>
                                        </td>
                                        <td>
                                            <h6 className="m-0">{item?.author || "-"} </h6>
                                        </td>
                                        {/* <td>
                                            <h6 className="m-0">{item?.is_active?.toString()}</h6>
                                        </td> */}
                                        <td>
                                            <div className='d-flex align-items-center gap-3'>
                                                <div className='cursor-pointer' onClick={() => { setMode(false); setStates(item); setModalShow(true) }}>
                                                    <i className="feather icon-edit" title='Edit' />
                                                </div>
                                                <div className='cursor-pointer' onClick={() => { setDeleteData(item?.id); setDeleteModalShow(true) }}>
                                                    <i className="feather icon-trash-2" title='Delete' />
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                )
                                    :
                                    <tr>
                                        <td colSpan={6} className='text-center'>
                                            There are no records available at the moment.
                                        </td>
                                    </tr>
                            }
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>

            {Boolean(data?.length) && paginationData?.total_pages > 1 &&
                <PaginationC data={paginationData}
                    onPageChange={(newPage) => {
                        setPage(newPage);
                    }} />}
            {/* add modal */}
            <Modal
                show={modalShow}
                onHide={handleClose}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>
                    <Card className='mb-0' style={{ borderBottom: "1px solid #f1f1f1" }}>
                        <Card.Header className='d-flex justify-content-between align-items-center'>
                            <Card.Title as="h5">{Boolean(mode) ? "Add " : "Edit "} {props?.title}</Card.Title>
                            <Modal.Header closeButton className='border-0'>
                            </Modal.Header>
                        </Card.Header>
                        <Card.Body>
                            {Boolean(subLoader) && <Loader loading={subLoader} />}
                            <Form noValidate validated={validated} onSubmit={handleSubmit}>
                                <Form.Group className="mb-4" as={Row} controlId="formHorizontalName">
                                    <Form.Label column sm={3}>
                                        Description
                                    </Form.Label>
                                    <Col sm={9}>
                                        <Form.Control as="textarea" rows={3} placeholder="Enter description" required value={states?.description || ""} name='description' onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">Please enter description.</Form.Control.Feedback>
                                        {/* <div>The most helpful reviews are 500 characters.</div> */}
                                    </Col>
                                </Form.Group>
                                <Form.Group className="mb-4" as={Row} controlId="formHorizontalName">
                                    <Form.Label column sm={3}>
                                        Author
                                    </Form.Label>
                                    <Col sm={9}>
                                        <Form.Control type="text" placeholder="Enter author" required value={states?.author || ""} name='author' onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">Please enter author.</Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                                <Form.Group className={`mb-3 ${!Boolean(mode) && "align-items-center"}`} as={Row} controlId="formHorizontalFirstName">
                                    <Form.Label column sm={3}>
                                        Image
                                    </Form.Label>
                                    <Col sm={9}>
                                        {Boolean(mode) ?
                                            <InputGroup className="mb-3">
                                                <Form.Control aria-describedby="custom-addons6" type="file" className="custom-file-input" id="validatedCustomFile2" required name='photo' onChange={handleChange} />
                                                <Form.Control.Feedback type="invalid">Please select image.</Form.Control.Feedback>
                                            </InputGroup>
                                            :
                                            <div className="position-relative" id="profile_image">
                                                <div className="d-flex">
                                                    <img
                                                        src={selectedImage || states?.photo}
                                                        onClick={handleImageClick}
                                                        className={`cursor-pointer profile-image`}
                                                    />
                                                </div>
                                                <input
                                                    type="file"
                                                    accept=".jpg, .jpeg, .png, webm, .webp"
                                                    name="photo"
                                                    style={{ display: "none" }}
                                                    ref={fileInputRef}
                                                    onChange={handleChange}
                                                />

                                                <img
                                                    src={camera}
                                                    onClick={handleImageClick}
                                                    className="cursor-pointer position-absolute top-50 start-20 translate-middle"
                                                    alt=""
                                                />
                                            </div>
                                        }
                                    </Col>
                                    {selectedImage && Boolean(mode) && (
                                        <div className="mt-3">
                                            <img src={selectedImage} alt="Preview" style={{ maxWidth: '30%', height: 'auto', borderRadius: '10px' }} />
                                        </div>
                                    )}
                                </Form.Group>
                                <div className='d-flex justify-content-end'>
                                    <Button type='submit' className='m-0'>{Boolean(mode) ? "Save" : "Update"}</Button>
                                </div>
                            </Form>
                        </Card.Body>
                    </Card>
                </Modal.Body>
            </Modal >

            {/* Delete */}
            <Modal Modal
                show={deleteModalShow}
                onHide={() => setDeleteModalShow(false)}
                size="sm"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>
                    {Boolean(subLoader) && <Loader loading={subLoader} />}
                    <Card className='mb-0' style={{ borderBottom: "1px solid #f1f1f1" }}>
                        <Card.Header className='d-flex justify-content-between align-items-center pe-0 pt-0 pb-0'>
                            <Card.Title as="h5">Delete {props?.title}</Card.Title>
                            <Modal.Header closeButton className='border-0'>
                            </Modal.Header>
                        </Card.Header>
                        <Card.Body className='pb-2'>
                            <h6>Are you sure you want to delete?</h6>
                            <div className='d-flex justify-content-center'>
                                <Button onClick={() => deleteCustomerReview()} className='mt-3 mb-0 mx-0'>Delete</Button>
                            </div>
                        </Card.Body>
                    </Card>
                </Modal.Body>
            </Modal >
        </>
    )
}

export default customerReview